<template>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { page } from '@/shared/helpers.js';

const props = defineProps({
  element: {
    type: Object,
    required: true
  },
  text: {
    type: Object,
    default: null
  }
});

const jsonLdSchema = computed(() => {
  if (!props.element) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: props.element.title,
    description: props.element.description?.replace(/<\/?[^>]+(>|$)/g, ''),
    articleBody: props.text?.content?.replace(/<\/?[^>]+(>|$)/g, '') || '',
    wordCount: props.text?.content ? props.text.content.replace(/<\/?[^>]+(>|$)/g, '').split(/\s+/).length : null,
    url: page.props.ziggy.location,
    datePublished: props.element.published_at || props.element.created_at,
    dateModified: props.element.updated_at,
    author: getAuthorData(),
    publisher: getPublisherData(),
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': page.props.ziggy.location
    },
    image: props.element.img_url || (props.element.company ? props.element.company.logo_url : null),
    interactionStatistic: [
      {
        '@type': 'InteractionCounter',
        'interactionType': {
          '@type': 'http://schema.org/ReadAction'
        },
        'userInteractionCount': props.element.views || 0
      }
    ],
    timeRequired: props.text?.duration ? `PT${props.text.duration}M` : null,
    keywords: props.element.tags ? props.element.tags.map(tag => tag.name || tag).join(', ') : null,
    articleSection: 'Статья'
  };

  Object.keys(schema).forEach(key => {
    if (schema[key] === null) {
      delete schema[key];
    }
  });

  return JSON.stringify(schema);
});

function getAuthorData() {
  if (props.element.users && props.element.users.length > 0) {
    const user = props.element.users[0];
    const authorData = {
      '@type': 'Person',
      name: user.contact ? `${user.contact.first_name} ${user.contact.last_name}`.trim() : 'Автор ProductLand'
    };

    if (user.job) {
      authorData.jobTitle = user.job.position;
      if (user.job.company) {
        authorData.affiliation = {
          '@type': 'Organization',
          name: user.job.company
        };
      }
    }

    return authorData;
  }

  return {
    '@type': 'Organization',
    name: props.element.company?.name || 'ProductLand',
    logo: props.element.company?.logo_url || '/img/favicon.svg'
  };
}

function getPublisherData() {
  return {
    '@type': 'Organization',
    name: 'ProductLand',
    logo: {
      '@type': 'ImageObject',
      url: '/img/favicon.svg'
    }
  };
}

onMounted(() => {
  if (props.element) {
    try {
      const oldScripts = document.querySelectorAll('script[type="application/ld+json"]');
      oldScripts.forEach(script => script.remove());
      
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = jsonLdSchema.value;
      
      document.head.appendChild(script);
      
      const meta = document.createElement('meta');
      meta.name = 'yandex-metrika-publisher-info';
      meta.content = 'json_ld';
      document.head.appendChild(meta);
      
      console.log('JSON-LD schema added for article:', props.element.title);
      
      if (window.ym) {
        window.ym(87205311, 'params', { schema_type: 'json_ld', has_schema: true });
        window.ym(99984857, 'params', { schema_type: 'json_ld', has_schema: true });
      }
    } catch (error) {
      console.error('Error adding JSON-LD schema:', error);
    }
  }
});
</script>
